<template>
  <div>
    <div v-if="Lib.checkPower('beauty-4-ckzptj',2)" class="giveAnalysis">
      <el-date-picker v-model="time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="expireTimeOption" @change="onChangeTime">></el-date-picker>
      <!-- <el-select v-model="value" placeholder="请选择" style="margin: 0 10px;">
      <el-option label="全部" value="1">
      </el-option>
      <el-option label="免赠活动" value="2">
      </el-option>
    </el-select> -->
      <div class="btnL">
        <el-button type="primary" @click="onDownload">导出报表</el-button>
        <el-button type="primary" @click="onPrint">打印报表</el-button>
      </div>
      <ul class="give-middle">
        <li>
          <p>{{ totalGiftCount }}</p>
          <p>赠送商品总数（件）</p>
        </li>
        <li>
          <p>{{ freeGiftCount }}</p>
          <p>免赠商品总数（件）</p>
        </li>
        <li>
          <p>{{ totalGiftMoney }}</p>
          <p>赠送商品优惠总额（元）</p>
        </li>
      </ul>
      <el-table tooltip-effect="light" :data="tableData" style="width: 100%;margin-bottom: 58px; margin-top :20px">
        <el-table-column prop="giftType" label="赠品类型"></el-table-column>
        <el-table-column prop="giveTime" label="交易时间"></el-table-column>
        <el-table-column prop="orderCode" label="订单号"></el-table-column>
        <el-table-column prop="giftName" label="商品名称"></el-table-column>
        <el-table-column prop="givingQuantity" label="数量"></el-table-column>
        <el-table-column prop="discountMoney" label="优惠金额"></el-table-column>
        <el-table-column prop="dutyName" label="操作人员"></el-table-column>
      </el-table>
      <el-pagination v-if="tableData.length!=0" background layout="prev, pager, next" :current-page.sync="pageNum" :total="total" :page-size="pageSize" @current-change="handleCurrentChange"></el-pagination>
    </div>
    <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import api from '../api/index';

export default {
  components: {
  },
  data() {
    return {
      time: [dayjs().subtract(30, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() > Date.now();
        }
      },
      tableData: [], // 赠品列表
      pageNum: 1, // 页码
      total: 0, // 总条数
      pageSize: 10, // 条数
      freeGiftCount: 0, // 免费赠品数量
      totalGiftCount: 0, // 赠品总数
      totalGiftMoney: 0, // 赠品总额
    };
  },
  activated() {
    this.getTableData();
  },
  methods: {
    // 获取表格数据
    getTableData() {
      const data = {
        beginTime: this.time[0],
        endTime: this.time[1],
        mainId: sessionStorage.getItem('mainId'),
        currentPage: this.pageNum,
        pageSize: this.pageSize,
      };
      api.getGiftStatistics(data).then((res) => {
        if (res.code === 0) {
          this.freeGiftCount = res.data.freeGiftCount;
          this.totalGiftCount = res.data.totalGiftCount;
          this.totalGiftMoney = res.data.totalGiftMoney;
          this.tableData = res.data.giftInfoPage.records;
          this.total = res.data.giftInfoPage.total;
        }
      });
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getTableData();
    },
    // 修改日期
    onChangeTime(e) {
      this.pageNum = 1;
      this.time = e;
      this.getTableData();
    },
    // 导出表格
    onDownload() {
      if (this.Lib.checkPower('beauty-4-dczptj') == false) return;
      this.$root.$children[0].fatherExport('exportGiftStatistics', this.time[0], this.time[1]);
    },
    // 网页打印
    onPrint() {
      if (this.Lib.checkPower('beauty-4-dyzptj') == false) return;
      this.$print({
        data: this.tableData,
        table_tol: [
          {
            prop: 'giftType',
            name: '赠品类型'
          },
          {
            prop: 'giveTime',
            name: '交易时间'
          },
          {
            prop: 'orderCode',
            name: '订单号'
          },
          {
            prop: 'giftName',
            name: '商品名称'
          },
          {
            prop: 'givingQuantity',
            name: '数量'
          },
          {
            prop: 'discountMoney',
            name: '优惠金额'
          },
          {
            prop: 'dutyName',
            name: '操作人员'
          },
        ],
        title: '赠品统计'
      });
    },
  }
};
</script>

<style lang="less" scoped>
.giveAnalysis{
  .give-middle{
    width: 100%;
    overflow: hidden;
    border: 1px solid #E6EBF5;
    padding: 28px 0;
    margin: 20px 0;
    list-style: none;
        display: flex;
    text-align: center;
    li{
      flex: 1;
      p:nth-child(1){
        font-size: 36px;
        color: #FD5C8C;
        line-height: 24px;
      }
      p:nth-child(2){
        font-size: 16px;
        color: #333333;
        line-height: 24px;
        padding-top:10px;
      }
    }
  }
}
</style>
<style>
.btnL {
    float: right;
}
</style>
